import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import Modal from '@/components/Modals/Modal';
import { IRateData } from '@/providers/HttpProvider/plugins/EnvioFlex/types';

interface ValidateCoverageProps {
  isOpen: boolean;
  onClose: () => void;
  rateData: IRateData | null;
  loading: boolean;
  onCreateOrder: () => void;
  orderStatus: string;
}

const ValidateCoverage = ({
  isOpen,
  onClose,
  rateData,
  loading,
  onCreateOrder,
  orderStatus,
}: ValidateCoverageProps) => {
  const theme = useTheme();

  const canCreateOrder = orderStatus === 'pending' || orderStatus === 'error';

  const handleCreateOrder = () => {
    onCreateOrder();
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Validación de cobertura"
        actions={
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: { xxs: 'column', md: 'row' },
              justifyContent: 'space-around',
              alignItems: 'center',
              gap: '1rem',
            }}
          >
            {rateData && !loading && (
              <>
                <Button
                  sx={{ width: '166px' }}
                  variant="contained"
                  onClick={handleCreateOrder}
                  disabled={!canCreateOrder}
                >
                  Generar orden
                </Button>
                <Button
                  sx={{ backgroundColor: theme.palette.dalia.main, width: '122px' }}
                  variant="contained"
                  onClick={onClose}
                >
                  Cancelar
                </Button>
              </>
            )}
            {!rateData && !loading && (
              <Button variant="contained" onClick={onClose}>
                Aceptar
              </Button>
            )}
          </Box>
        }
      >
        {loading && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '2rem',
            }}
          >
            <CircularProgress />
          </Box>
        )}
        {!loading && rateData && (
          <>
            <Typography
              variant="body1"
              sx={{ padding: '1rem', color: theme.palette.grey[500], textAlign: 'center' }}
            >
              El costo total del envío es de: ${(rateData.prices?.total ?? 0).toFixed(2)}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: theme.palette.grey[500], textAlign: 'center' }}
            >
              Tipo de envío: {rateData.deliveryType}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.grey[400], textAlign: 'center', mt: 1 }}
            >
              ETA: {rateData.eta.dateTime}
            </Typography>
          </>
        )}
        {!loading && !rateData && (
          <Typography
            variant="body1"
            sx={{ padding: '1rem', color: theme.palette.error.main, textAlign: 'center' }}
          >
            No se pudo validar la cobertura para esta orden. Por favor, intenta nuevamente.
          </Typography>
        )}
      </Modal>
    </>
  );
};

export default ValidateCoverage;
